import { CASES } from './constants';

export const updateProductGate = (payload) => {
    return { type: CASES.UPDATE_PRODUCT_GATE, payload };
};

export const updateProductGateFrom = ({ key, data }) => {
    return {
        type: CASES.UPDATE_PRODUCT_GATE_FORM,
        payload: { key, data },
    };
};

export const clearProductGate = () => {
    return { type: CASES.CLEAR_PRODUCT_GATE, payload: {} };
};
